import _ from "lodash";
import client from "lib/apolloClient/client";
import { getUserProfileDetailsQuery } from "./ProfileQueries";

export const getUserProfileDetailsFromCache = ({ id, type }) => {
  let queryData;
  try {
    queryData = client.readQuery({
      query: getUserProfileDetailsQuery,
      variables: {
        id,
        type,
      },
    });
  } catch (error) {
    // console.log(error);
    return {};
  }
  if (queryData !== null) {
    return _.get(queryData, "node", {});
  }
  return {};
};

export const writeUserProfileDetailsToCache = ({ id, data, type }) => {
  try {
    client.writeQuery({
      query: getUserProfileDetailsQuery,
      variables: {
        id,
        type,
      },
      data,
    });
  } catch (error) {
    // console.log(error);
  }
};
